import { useRouter } from 'vue-router';

export function useGoto() {
  const router = useRouter();

  // 返回上一页
  function goBack() {
    router.go(-1);
  }

  // 跳转到首页
  function gotoHome() {
    location.href = location.origin;
  }

  return {
    goBack,
    gotoHome,
  };
}
